import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/Login',
			component: resolve => require(['@/page/Login.vue'], resolve),
		}, {
			path: '/',
			component: resolve => require(['@/page/index.vue'], resolve),
		},
		{
			path: '/index',
			component: resolve => require(['@/page/index.vue'], resolve),
			redirect: '/mini_app/manage_banner',
			children: [ 
				//首页
				{
					path: '/home/home_banner',
					component: resolve => require(['@/page/home/home_banner.vue'], resolve)
				}, // 轮播图管理 - 首页
				{
					path: '/home/add_banner',
					component: resolve => require(['@/page/home/add_banner.vue'], resolve)
				}, // 添加轮播图-轮播图管理-首页

				{
					path: '/home/home_project',
					component: resolve => require(['@/page/home/home_project.vue'], resolve)
				}, // 项目管理	
				{
					path: '/home/project_detail',
					component: resolve => require(['@/page/home/project_detail.vue'], resolve)
				}, // 项目详情	
				{
					path: '/home/add_project',
					component: resolve => require(['@/page/home/add_project.vue'], resolve)
				}, // 添加项目

				{
					path: '/home/project_type',
					component: resolve => require(['@/page/home/project_type.vue'], resolve)
				}, // 项目类型
				{
					path: '/home/add_project_type',
					component: resolve => require(['@/page/home/add_project_type.vue'], resolve)
				}, //添加项目类型
				{
					path: '/marketing/resources_list',
					component: resolve => require(['@/page/marketing/resources_list.vue'], resolve)
				}, //资源管理列表
				{
					path: '/marketing/add_resources_list',
					component: resolve => require(['@/page/marketing/add_resources_list.vue'], resolve)
				}, //添加资源管理
				{
					path: '/marketing/export_resources',
					component: resolve => require(['@/page/marketing/export_resources.vue'], resolve)
				}, // 导入资源
				{
					path: '/marketing/channel_type_list',
					component: resolve => require(['@/page/marketing/channel_type_list'], resolve)
				}, // 渠道类型列表 
				{
					path: '/marketing/add_channel_type',
					component: resolve => require(['@/page/marketing/add_channel_type.vue'], resolve)
				}, //添加渠道类型 

				 
				{
					path: '/personnel/staff_list',
					component: resolve => require(['@/page/personnel/staff_list.vue'], resolve)
				}, // 员工列表
				{
					path: '/personnel/add_staff',
					component: resolve => require(['@/page/personnel/add_staff.vue'], resolve)
				}, //添加员工
				{
					path: '/personnel/export_add_staff',
					component: resolve => require(['@/page/personnel/export_add_staff.vue'], resolve)
				}, //添加员工

				{
					path: '/personnel/staff_detail',
					component: resolve => require(['@/page/personnel/staff_detail.vue'], resolve)
				}, //员工详情 

				{
					path: '/personnel/customer_list',
					component: resolve => require(['@/page/personnel/customer_list.vue'], resolve)
				}, // 客户列表
				{
					path: '/personnel/add_customer',
					component: resolve => require(['@/page/personnel/add_customer.vue'], resolve)
				}, // 添加客户
				{
					path: '/personnel/export_add_customer',
					component: resolve => require(['@/page/personnel/export_add_customer.vue'], resolve)
				}, // 批量添加客户
				{
					path: '/personnel/w_user_list',
					component: resolve => require(['@/page/personnel/w_user_list.vue'], resolve)
				}, // 用户管理列表
				{
					path: '/personnel/w_user_detail',
					component: resolve => require(['@/page/personnel/w_user_detail.vue'], resolve)
				}, // 用户详情
				{
					path: '/personnel/company_list',
					component: resolve => require(['@/page/personnel/company_list.vue'], resolve)
				}, // 公司管理
				{
					path: '/personnel/add_company',
					component: resolve => require(['@/page/personnel/add_company.vue'], resolve)
				}, //添加公司
				{
					path: '/personnel/position_list',
					component: resolve => require(['@/page/personnel/position_list.vue'], resolve)
				}, //  职位管理
				{
					path: '/personnel/add_position',
					component: resolve => require(['@/page/personnel/add_position.vue'], resolve)
				}, //  添加职位
				{
					path: '/personnel/department_list',
					component: resolve => require(['@/page/personnel/department_list.vue'], resolve)
				}, //  职位管理
				{
					path: '/personnel/add_department',
					component: resolve => require(['@/page/personnel/add_department.vue'], resolve)
				}, //  添加职位

				 
				{
					path: '/personnel/message_list',
					component: resolve => require(['@/page/personnel/message_list.vue'], resolve)
				}, // 消息列表
				{
					path: '/personnel/message_detail',
					component: resolve => require(['@/page/personnel/message_detail.vue'], resolve)
				}, // 消息详情 
				{
					path: '/order/business_order',
					component: resolve => require(['@/page/order/business_order.vue'], resolve)
				}, //商家支付订单-订单
				{
					path: '/order/problem_detail',
					component: resolve => require(['@/page/order/problem_detail.vue'], resolve)
				}, //商家支付订单-订单

				{
					path: '/order/mt_order',
					component: resolve => require(['@/page/order/mt_order.vue'], resolve)
				}, //美团门票订单-订单
				{
					path: '/order/xc_order',
					component: resolve => require(['@/page/order/xc_order.vue'], resolve)
				}, //携程门票订单-订单

 
				//用户
				{
					path: '/user/add_dr',
					component: resolve => require(['@/page/user/add_dr.vue'], resolve)
				}, // 导入界面
				//用户
				{
					path: '/user/add_user',
					component: resolve => require(['@/page/user/add_user.vue'], resolve)
				}, // 商家微信用户 -用户
				{
					path: '/user/user_douyin',
					component: resolve => require(['@/page/user/user_douyin.vue'], resolve)
				}, // 抖音用户 -用户
				{
					path: '/user/user_detail',
					component: resolve => require(['@/page/user/user_detail.vue'], resolve)
				}, // 查看详情-用户管理 -用户
				//统计
				{
					path: '/statistics/finance',
					component: resolve => require(['@/page/statistics/finance.vue'], resolve)
				}, // 财务统计 -统计
				{
					path: '/statistics/ticket',
					component: resolve => require(['@/page/statistics/ticket.vue'], resolve)
				}, // 门票订单统计 -统计
				{
					path: '/statistics/business',
					component: resolve => require(['@/page/statistics/business.vue'], resolve)
				}, // 商家支付统计 -统计
				//商家
				{
					path: '/system/cashier',
					component: resolve => require(['@/page/system/cashier.vue'], resolve)
				}, // 商家管理-商家
				{
					path: '/system/add_business',
					component: resolve => require(['@/page/system/add_business.vue'], resolve)
				}, // 添加商家-商家管理-商家
				{
					path: '/system/shop_business',
					component: resolve => require(['@/page/system/shop_business.vue'], resolve)
				}, // 门店管理-商家管理-商家
				{
					path: '/system/add_shop',
					component: resolve => require(['@/page/system/add_shop.vue'], resolve)
				}, // 添加门店-门店管理-商家管理-商家
				{
					path: '/system/binging',
					component: resolve => require(['@/page/system/binging.vue'], resolve)
				}, // 绑定收款人-收银商家-商家


				//系统
				{
					path: '/set_up/city_message',
					component: resolve => require(['@/page/set_up/city_message.vue'], resolve)
				}, // 系统菜单 - 系统
				{
					path: '/set_up/role_list',
					component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
				}, // 系统角色 - 系统
				{
					path: '/set_up/add_role',
					component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
				}, // 添加角色-系统角色 - 系统
				{
					path: '/set_up/menu_list',
					component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
				}, // 系统菜单 - 系统
				{
					path: '/set_up/add_menu',
					component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
				}, // 添加菜单-系统菜单 - 系统
				{
					path: '/set_up/user_list',
					component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
				}, // 添加菜单-系统菜单 - 系统
				{
					path: '/set_up/addStaff',
					component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
				}, // 添加菜单-系统菜单 - 系统

			]
		},
	],
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})


// WEBPACK FOOTER //
// ./src/router/index.js